var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2002 18.5C18.1669 18.5 18.9504 19.283 18.9504 20.2495C18.9504 21.2159 18.1669 22 17.2002 22C16.2335 22 15.45 21.2159 15.45 20.2495C15.45 19.283 16.2335 18.5 17.2002 18.5ZM6.19906 18.5C7.16577 18.5 7.94931 19.283 7.94931 20.2495C7.94931 21.2159 7.16577 22 6.19906 22C5.23349 22 4.44995 21.2159 4.44995 20.2495C4.44995 19.283 5.23349 18.5 6.19906 18.5ZM6.17659 12.8L6.30956 14.2943C6.33252 14.5523 6.54863 14.75 6.80759 14.75H19.8728L19.6482 16.75H11.1484H6.39344C5.37297 16.75 4.51615 15.9817 4.40528 14.9673L3.37089 5.50244H1.40015L1.19995 3.5H4.22447C4.72573 3.5 5.14954 3.87111 5.21572 4.36798L5.36649 5.5H21L20.3813 11.0227C20.2679 12.0347 19.4122 12.8 18.3937 12.8H6.17659Z",
    fill: "#9299A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.c1cde459e45cc294a4ceac7de8cbacdb.svg";
export { ForwardRef as ReactComponent };